import React, { useState } from "react";
import "./Anniversary.css";

const TypesOfFunction = () => {
  const [activeTab, setActiveTab] = useState("venue");

  const services = [
    "Decoration",
    "Hospitality & guests support",
    "DJ & entertainment",
    "Guests transfers",
    "Venue selection",
    "Invitations",
    "Trousseau packing",
    "Photography/ Videography",
    "Catering",
    "Styling & grooming",
    "Wedding cake",
    "Band & baraat"
  ];

    const feeRanges = [
    "Under ₹50,000",
    "₹50,000 - ₹99,999",
    "₹1,00,000 - ₹1,49,999",
    "₹1,50,000 - ₹1,99,999",
    "₹2,00,000 - ₹2,49,999",
    "₹2,50,000 - ₹2,99,999",
    "₹3,00,000 - ₹3,99,999",
    "₹4,00,000 - ₹4,99,999",
    "₹5,00,000 and more"
  ];

  const sampleData = [
    { id: 1, title: "Grand Palace", description: "Luxury venue for big events." },
    { id: 2, title: "Elegant Decorators", description: "Specialized in wedding themes." },
    { id: 3, title: "Royal Catering", description: "Premium catering services." }
  ];

  return (
    <div className="function-page">
      {/* Left Filter Section */}
      <div className="filter-panel">
        <h3>Filters</h3>

        {/* Services Section */}
        <div className="filter-section">
          <h4>Services</h4>
          <div className="checkbox-list">
            {services.map((service, idx) => (
              <label key={idx} className="checkbox-item">
                <input type="checkbox" />
                {service}
              </label>
            ))}
          </div>
        </div>

        
        {/* Fee Section */}
        <div className="filter-section">
          <h4>Price Range</h4>
          <div className="checkbox-list">
            {feeRanges.map((fee, idx) => (
              <label key={idx} className="checkbox-item">
                <input type="checkbox" />
                {fee}
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* Right Content Section */}
      <div className="content-panel">
        <div className="tabs">
          <button
            className={activeTab === "venue" ? "active" : ""}
            onClick={() => setActiveTab("venue")}
          >
            Venues
          </button>
          <button
            className={activeTab === "vendors" ? "active" : ""}
            onClick={() => setActiveTab("vendors")}
          >
            Vendors
          </button>
        </div>

        <div className="cards-container">
          {sampleData.map((item) => (
            <div className="card" key={item.id}>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TypesOfFunction;
